import {
  Box,
  Chip,
  FormControlLabel,
  FormGroup,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import IOSSwitch from "../../../components/IsoSwitch";
import SubscriptionCards from "./SubscriptionCards";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_best_pr": {
    fontWeight: 700,
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

function Plans() {
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_best_pr">
        Pricing & Plans
      </Typography>
      <Typography
        variant="body1"
        textAlign={"center"}
        fontWeight={300}
        maxWidth={500}
        margin={"auto"}
        letterSpacing={"0.2px"}
      >
        With lots of unique blocks, you can easily build a page without coding.
        Build your next landing page.
      </Typography>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        spacing={2}
        my={3}
      >
        <Typography variant="body1">Monthly</Typography>
        <FormGroup>
          <FormControlLabel
            sx={{
              mx: "0px",
            }}
            control={<IOSSwitch defaultChecked />}
          />
        </FormGroup>
        <Typography variant="body1">Yearly</Typography>
        <Chip
          label="Save 25%"
          sx={{
            backgroundColor: "#ea580c1c",
            "& .MuiChip-label": {
              color: "#EA580C",
              fontWeight: 600,
            },
          }}
        />
      </Stack>
      <SubscriptionCards />
    </MainView>
  );
}

export default Plans;
